<template>
    <section class="md-testimonial refer-friend">
        <div class="refer-title">
            {{ $t('md-testimonial.introduceAFriendTo') }}
        </div>
        <div class="refer-subtitle">
            {{ $t('md-testimonial.ifYouLikeTheWork') }}
        </div>
        <v-form
            ref="form"
            class="refer-form clearfix"
            :onSuccess="submitSuccess"
        >
            <p class="item-title required">
                {{ $t('md-testimonial.yourFriendsName') }}
            </p>
            <v-input
                type="text"
                name="friendName"
                :maxlength="30"
                :required="true"
            />
            <p class="item-title required">
                {{ $t('md-testimonial.yourFriendsEmail') }}
            </p>
            <v-input
                type="email"
                name="friendEmail"
                :maxlength="40"
                :required="true"
                :validateConfig="{
                    async: '/api-site/register/hasUser?account={value}'
                }"
            />
            <p class="item-title">
                {{ $t('md-testimonial.yourFriendsPhone') }}
            </p>
            <v-input type="tel" name="friendPhone" />
            <p class="item-title">{{ $t('md-testimonial.message') }}</p>
            <v-input
                ref="message"
                name="message"
                tag="textarea"
                :placeholder="$t('md-testimonial.tellMeAnythingElse')"
            />
            <input
                type="submit"
                :value="$t('md-testimonial.referSubmit')"
                class="submit"
            />
        </v-form>
    </section>
</template>

<script>
import vForm from '@/components/v-form.vue';
import vInput from '@/components/v-input.vue';
import signLog from '@/components/sign-log';
import { mapState } from 'pinia';
import { useUserStore } from "@/store";
import util from '../../../common/util';



export default {
    name: 'refer-friend',
    i18next: {
        ns: 'md-testimonial'
    },
    components: {
        vForm,
        vInput
    },
    computed: {
        ...mapState(useUserStore, {
            user: store => store.user
        })
    },
    methods: {
        submitSuccess(data = {}) {
            // TODO:  Add attributes directly on the instance to prevent repeated submissions , not good practice
            if (this.submitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            //TODO: Change the code from  ../../../components/leave-msg/leave-msg#54
            // TODO:  The processing logic of verifying login should be placed in the interceptor
            if (this.user) {
                this.referFriend(data, true);
            } else {
                //  Successful login triggers automatic submission
                signLog.register({
                    onsuccess: () => {
                        this.referFriend(data, true);
                    }
                });
                this.submitDisabled = false;
            }
        },
        /**  Test Data
         * a@132.com
         * 619-807-4090
         */
        referFriend(referInfo, isToast) {
            this.axiosIns
                .post('/api-site/refer-friend', referInfo)
                .then(res => {
                    if (res.status.code === 0) {
                        this.$refs.form.reset({
                            friendName: '',
                            friendEmail: '',
                            friendPhone: '',
                            message: ''
                        });
                        isToast &&
                            util.toast(
                                this.$t('md-testimonial.thankYouYourReferral'),
                                1000
                            );
                    } else {
                        // TODO:  Error handling and failure status codes should be placed in a unified interceptor and should not appear here
                        throw new Error('error');
                    }
                })
                .catch(e => {
                    isToast &&
                        util.toast(this.$t('md-testimonial.submittedFailed'));
                })
                .finally(() => {
                    this.submitDisabled = false;
                });
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.md-testimonial.refer-friend {
    .refer-title {
        font-size: 24px;
        color: #010102;
    }
    .refer-subtitle {
        margin-top: 12px;
        font-size: 18px;
        color: #787878;
    }
    .refer-form {
        margin-top: 38px;
        .item-title {
            font-size: 16px;
            font-family: var(--font-black);
            color: #010102;
            margin-top: 18px;
            &.required::after {
                content: '*';
                color: #ff4d4d;
                font-family: var(--font-bold);
            }
        }
        input[type='text'],
        input[type='email'],
        input[type='tel'] {
            width: 100%;
            height: 50px;
            padding: 0 16px;
            font-size: 15px;
            margin-top: 16px;
            color: var(--color-text);
            background-color: #f7f7f7;
            border: 1px solid #dbdbdb;
            box-shadow: inset 0 0 3px 0 rgba(201, 201, 201, 0.8);
        }
        textarea {
            width: 100%;
            height: 235px;
            padding: 16px;
            margin-top: 16px;
            font-size: 15px;
            color: var(--color-text);
            background-color: #f7f7f7;
            border: 1px solid #dbdbdb;
            box-shadow: inset 0 0 3px 0 rgba(201, 201, 201, 0.8);
        }
        .submit {
            float: right;
            width: 130px;
            height: 40px;
            margin-top: 30px;
            border-radius: 2px;
            background-color: #f3ab1a;
            font-size: 16px;
            font-family: var(--font-title);
            color: #fff;
        }
    }
    @include media-600 {
        .refer-subtitle {
            font-size: 16px;
        }
        .refer-form {
            margin-top: 22px;
            text-align: center;
            .item-title {
                font-size: 15px;
                text-align: left;
            }
            .mg-error {
                text-align: left;
            }
            .submit {
                float: none;
                margin-top: 40px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>
